// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jjtwt9GyBYpHYY {
  margin-right: 16px;
  padding: 10px 18px;
  white-space: nowrap;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .Jjtwt9GyBYpHYY {
    width: 100%;
    margin-right: 0;
    text-align: center;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Jjtwt9GyBYpHYY`
};
export default ___CSS_LOADER_EXPORT___;
